/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationOfferGroupProtectionQuery from '../graphql/queries/GetSimulationOfferGroupProtectionQuery.js';

const useGetSimulationOfferGroupProtectionQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationOfferGroupProtectionQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationOfferGroupProtection: R.omit(['__typename'], data?.getSimulationOfferGroupProtection_simulation_offer_group_protection || {})
  };
};

export default useGetSimulationOfferGroupProtectionQuery;
